




























import { SimilarityFaultFrequencyItem } from '@/interfaces/types/AnalysisResult';
import { downloadLocalData } from '@/utils/axiosAgentInstance';
import Vue, { PropType } from 'vue';
export default Vue.extend({
  props: {
    data: {
      type: Object as PropType<SimilarityFaultFrequencyItem>,
    },
    rootPath: {
      type: String,
    },
  },
  data(): {
    imageFullPath: string;
    imageSourceURL: string | null;
  } {
    return {
      imageFullPath: this.rootPath + '/' + this.data.file,
      imageSourceURL: null,
    };
  },
  mounted() {
    downloadLocalData(this.imageFullPath, 'image').then((result) => {
      this.imageSourceURL = result;

      if (this.imageSourceURL) {
        (this.$refs.image as HTMLImageElement).src = this.imageSourceURL;
        (this.$refs.imageRef as HTMLAnchorElement).href = this.imageSourceURL;
      }
    });
  },
  methods: {
    copyFullPath() {
      window.navigator.clipboard.writeText(this.imageFullPath);
    },
  },
});
